import { useNetworkStatus } from '@hooks/useNetworkStatus'
import { useAppLayout } from '@hooks/useAppLayout'
import UpdateBanner from '../interface/banners/UpdateBanner'
import LanguageBanner from '../interface/banners/LanguageBanner'
import FirefoxWarning from '../interface/modals/FirefoxWarning'
import { OfflineBanner } from '../interface/banners/OfflineBanner'
import Header from './Header'
import Footer from './Footer'

/**
 * Layout wrapper for all app screens
 *
 * @param {Object} props
 * @param {ReactNode} props.children - Screen content to wrap
 * @param {string} [props.currentPage] - Override for static pages (passed from StaticPageHandler)
 */
export default function ScreenWrapper ({ children, currentPage = null }) {
  const isOnline = useNetworkStatus()
  const { showHeader, showFooter } = useAppLayout(currentPage)

  return (
    <>
      {showHeader && <Header />}
      <main id='main-content'>
        <FirefoxWarning />
        {!isOnline && <OfflineBanner />}
        {children}
        <LanguageBanner />
        <UpdateBanner />
      </main>
      {/* Footer rendered based on prop decision from useAppLayout */}
      {showFooter && <Footer />}
    </>
  )
}
